import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Title } from '../../../shared/dto/title/title';

@Injectable({
	providedIn: 'root',
})
export class TitleService {
	constructor(private http: HttpClient) {}

	getTitles(
		title: Title,
		getPayments: boolean,
		currentPage: number,
		sizePage: number
	) {
		let request = '';

		if (title.dealer !== undefined && title.dealer !== 0) {
			request = 'dealerCode=' + title.dealer;
		}

		if (title.dealerMatrix !== undefined && title.dealerMatrix !== 0) {
			request += request.length > 0 ? '&' : '';
			request += 'dealerMatrizCode=' + title.dealerMatrix;
		}

		if (title.document !== undefined && title.document !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'document=' + title.document;
		}

		// 		if(getPayments !== undefined && getPayments === true){
		// 			request += (request.length > 0) ? '&' : '';
		// 			request += 'paymentTitles=' + true;
		// 		}

		if (
			title.paymentTitle != undefined &&
			title.paymentTitle.datePaymentStart != undefined &&
			title.paymentTitle.datePaymentEnd != undefined
		) {
			request += request.length > 0 ? '&' : '';
			request +=
				'datePaymentStart=' +
				title.paymentTitle.datePaymentStart.toISOString().split('T')[0];
			request +=
				'&datePaymentEnd=' +
				title.paymentTitle.datePaymentEnd.toISOString().split('T')[0];
		}

		if (title.currentStatus !== undefined && title.currentStatus !== 0) {
			request += request.length > 0 ? '&' : '';
			request += 'currentStatus=' + title.currentStatus;
		}

		if (title.currentStatusList?.length > 0) {
			request += request.length > 0 ? '&' : '';
			request += 'currentStatusList=' + title.currentStatusList;
		}

		if (
			title.contributionStatus !== undefined &&
			title.contributionStatus !== 0
		) {
			request += request.length > 0 ? '&' : '';
			request += 'contributionStatus=' + title.contributionStatus;
		}

		if (title.dateTitleStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'dateTitleStart=' +
				title.dateTitleStart.toISOString().split('T')[0] +
				'&dateTitleEnd=' +
				title.dateTitleEnd.toISOString().split('T')[0];
		}

		if (title.dueDateStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'dueDateStart=' +
				title.dueDateStart.toISOString().split('T')[0] +
				'&dueDateEnd=' +
				title.dueDateEnd.toISOString().split('T')[0];
		}

		if (title.paymentTitle.datePaymentStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'datePaymentStart=' +
				title.paymentTitle.datePaymentStart
					.toISOString()
					.split('T')[0] +
				'&datePaymentEnd=' +
				title.paymentTitle.datePaymentEnd.toISOString().split('T')[0] +
				'&paymentTitles=true';
		}

		if (title.dpp !== undefined) {
			request += request.length > 0 ? '&' : '';
			request += 'dpp=' + title.dpp;
		}

		if (title.testDrive !== undefined) {
			request += request.length > 0 ? '&' : '';
			request += 'testDrive=' + title.testDrive;
		}

		if (title.accountFundId !== undefined && title.accountFundId > -1) {
			request += request.length > 0 ? '&' : '';
			request += 'accountFundId=' + title.accountFundId;
		}

		if (title.dateTransmissionStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'dateTransmissionStart=' +
				title.dateTransmissionStart.toISOString().split('T')[0];
		}

		if (title.vin !== undefined && title.vin.length > 0) {
			request += request.length > 0 ? '&' : '';
			request += 'vin=' + title.vin;
		}

		if (title.cvvgDateStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'cvvgDateStart=' +
				title.cvvgDateStart.toISOString().split('T')[0] +
				'&cvvgDateEnd=' +
				title.cvvgDateEnd.toISOString().split('T')[0];
		}

		if (title.cancelDateStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'cancelDateStart=' +
				title.cancelDateStart.toISOString().split('T')[0] +
				'&cancelDateEnd=' +
				title.cancelDateEnd.toISOString().split('T')[0];
		}

		request += '&page=' + currentPage + '&size=' + sizePage;

		return this.http.get<any>(
			environment.financialUrl + '/title?' + request
		);
	}

	putTitle(title: Title) {
		return this.http.put(
			environment.financialUrl +
				'/title/' +
				sessionStorage.getItem('country') +
				'/' +
				title.id,
			title
		);
	}

	getSettledTitles(
		dealerCode: string,
		dataInicio: string,
		dataFim: string,
		dealerMatrizCode: string
	) {
		let request = '';

		if (dealerCode !== undefined && dealerCode !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'dealerCode=' + dealerCode;
		}

		if (dealerMatrizCode !== undefined && dealerMatrizCode !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'dealerMatrizCode=' + dealerMatrizCode;
		}

		request += request.length > 0 ? '&' : '';
		request += 'dataInicio=' + dataInicio + '&dataFim=' + dataFim;

		return this.http.get<any>(
			environment.financialUrl + '/title/getSettledTitles?' + request
		);
	}

	getOverdueTitles(dealerCode: string, dealerMatrizCode: string) {
		let request = '';

		if (dealerCode !== undefined && dealerCode !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'dealerCode=' + dealerCode;
		}

		if (dealerMatrizCode !== undefined && dealerMatrizCode !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'dealerMatrizCode=' + dealerMatrizCode;
		}

		return this.http.get<any>(
			environment.financialUrl + '/title/getOverdueTitles?' + request
		);
	}

	getStatusTitle() {
		return this.http.get<any>(environment.financialUrl + '/title/status');
	}

	getContributionStatusTitle() {
		return this.http.get<any>(
			environment.financialUrl + '/title/contributionStatus'
		);
	}

	buildFile(typeFile: string, product: string) {
		return this.http.get(
			environment.financialUrl +
				'/title/build?type=' +
				typeFile +
				'&product=' +
				product,
			{ responseType: 'text' }
		);
	}

	resendTitle(titleList: Title[]) {
		return this.http.put(
			environment.financialUrl +
				'/title/' +
				sessionStorage.getItem('country') +
				'/resend',
			titleList
		);
	}

	getTitlesReport(title: Title) {
		let request = '';

		if (title.dealer !== undefined && title.dealer !== 0) {
			request = 'dealerCode=' + title.dealer;
		}

		if (title.dealerMatrix !== undefined && title.dealerMatrix !== 0) {
			request += request.length > 0 ? '&' : '';
			request += 'dealerMatrizCode=' + title.dealerMatrix;
		}

		// 		if(getPayments !== undefined && getPayments === true){
		// 			request += (request.length > 0) ? '&' : '';
		// 			request += 'paymentTitles=' + true;
		// 		}

		if (
			title.paymentTitle != undefined &&
			title.paymentTitle.datePaymentStart != undefined &&
			title.paymentTitle.datePaymentEnd != undefined
		) {
			request += request.length > 0 ? '&' : '';
			request +=
				'datePaymentStart=' +
				title.paymentTitle.datePaymentStart.toISOString().split('T')[0];
			request +=
				'&datePaymentEnd=' +
				title.paymentTitle.datePaymentEnd.toISOString().split('T')[0];
		}

		if (title.currentStatus !== undefined && title.currentStatus !== 0) {
			request += request.length > 0 ? '&' : '';
			request += 'currentStatus=' + title.currentStatus;
		}

		if (title.currentStatusList?.length > 0) {
			request += request.length > 0 ? '&' : '';
			request += 'currentStatusList=' + title.currentStatusList;
		}

		if (
			title.contributionStatus !== undefined &&
			title.contributionStatus !== 0
		) {
			request += request.length > 0 ? '&' : '';
			request += 'contributionStatus=' + title.contributionStatus;
		}

		if (title.dateTitleStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'dateTitleStart=' +
				title.dateTitleStart.toISOString().split('T')[0] +
				'&dateTitleEnd=' +
				title.dateTitleEnd.toISOString().split('T')[0];
		}

		if (title.dueDateStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'dueDateStart=' +
				title.dueDateStart.toISOString().split('T')[0] +
				'&dueDateEnd=' +
				title.dueDateEnd.toISOString().split('T')[0];
		}

		if (title.paymentTitle.datePaymentStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'datePaymentStart=' +
				title.paymentTitle.datePaymentStart
					.toISOString()
					.split('T')[0] +
				'&datePaymentEnd=' +
				title.paymentTitle.datePaymentEnd.toISOString().split('T')[0] +
				'&paymentTitles=true';
		}

		if (title.dpp !== undefined) {
			request += request.length > 0 ? '&' : '';
			request += 'dpp=' + title.dpp;
		}

		if (title.testDrive !== undefined) {
			request += request.length > 0 ? '&' : '';
			request += 'testDrive=' + title.testDrive;
		}

		if (title.accountFundId !== undefined && title.accountFundId >= 0) {
			request += request.length > 0 ? '&' : '';
			request += 'accountFundId=' + title.accountFundId;
		}

		if (title.dateTransmissionStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'dateTransmissionStart=' +
				title.dateTransmissionStart.toISOString().split('T')[0] +
				'&dateTransmissionEnd=' +
				title.dateTransmissionEnd.toISOString().split('T')[0];
		}

		if (title.vin !== undefined && title.vin.length > 0) {
			request += request.length > 0 ? '&' : '';
			request += 'vin=' + title.vin;
		}

		if (title.cvvgDateStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'cvvgDateStart=' +
				title.cvvgDateStart.toISOString().split('T')[0] +
				'&cvvgDateEnd=' +
				title.cvvgDateEnd.toISOString().split('T')[0];
		}

		if (title.cancelDateStart !== undefined) {
			request += request.length > 0 ? '&' : '';
			request +=
				'cancelDateStart=' +
				title.cancelDateStart.toISOString().split('T')[0] +
				'&cancelDateEnd=' +
				title.cancelDateEnd.toISOString().split('T')[0];
		}

		if (title.document !== undefined && title.document !== '') {
			request += request.length > 0 ? '&' : '';
			request += 'document=' + title.document;
		}

		request += '&typeFile=' + title.typeFile;

		return this.http.get(
			environment.financialUrl + '/title/report?' + request,
			{ responseType: 'blob' }
		);
	}
}
